export default __webpack_public_path__ + "static/media/thumbnail.0a670842.webp";